import { render, staticRenderFns } from "./PrecioSku.vue?vue&type=template&id=b486606e&scoped=true&"
import script from "./PrecioSku.vue?vue&type=script&lang=js&"
export * from "./PrecioSku.vue?vue&type=script&lang=js&"
import style0 from "./PrecioSku.vue?vue&type=style&index=0&id=b486606e&prod&lang=scss&"
import style1 from "./PrecioSku.vue?vue&type=style&index=1&id=b486606e&prod&scoped=true&lang=css&"
import style2 from "./PrecioSku.vue?vue&type=style&index=2&id=b486606e&prod&lang=scss&"
import style3 from "./PrecioSku.vue?vue&type=style&index=3&id=b486606e&prod&lang=scss&scoped=true&"
import style4 from "./PrecioSku.vue?vue&type=style&index=4&id=b486606e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b486606e",
  null
  
)

export default component.exports